import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-230c699b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "landing-pages-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_landing_page_login_form = _resolveComponent("landing-page-login-form")!
  const _component_login_sub_page = _resolveComponent("login-sub-page")!
  const _component_main_authentication_layout = _resolveComponent("main-authentication-layout")!

  return (_openBlock(), _createBlock(_component_main_authentication_layout, { class: "landing-page" }, {
    default: _withCtx(() => [
      (_ctx.isSmallWidth)
        ? (_openBlock(), _createBlock(_component_landing_page_login_form, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_login_sub_page, {
              class: "snap-item",
              showQuote: !_ctx.isSmallerThanLargeWidth,
              version: _ctx.version
            }, null, 8, ["showQuote", "version"])
          ]))
    ]),
    _: 1
  }))
}